import React, {useState,useEffect} from 'react';
import {Button, Col, Form, InputNumber, message, Row, Select} from "antd";
import './index.css'
import {useSelector, useDispatch} from 'react-redux';
import {getAlipayInfo, getAlipayResult, getWalletInfo} from '../../../../api/user'
import {setCurrencies} from "../../../../store/modules/user";

//充值
const RechargeApp = (props) => {
    //父组件传输
    const {handleCloseRechargeModel, handleOk} = props
    const dispatch = useDispatch()
    const [payCode, setPayCode] = useState('')
    const [isPay, setIsPay] = useState(false)
    const [form] = Form.useForm();
    var timer = null,payOrderId=null;
    useEffect(() => {
        return () => {
            if(timer) clearInterval(timer)
        };
    }, []);
    const onFinish = (values) => {
        getAlipayInfo({'product_id': 'wallet_vCNY_balance_pay_as_needed', quantity: values.quantity}).then(res => {
            if (res.code === 200) {
                setPayCode(res?.data?.qr_code_url || null)
                payOrderId = res?.data?.order_id || null
                timer = setInterval(()=>{
                    getAlipayInfoResult()
                },5000)
            }
        })
        // handleOk()
    };
    const getAlipayInfoResult = () => {
        getAlipayResult({order_id:payOrderId}).then(res => {
            if (res.code === 200) {
                setIsPay(true)
                clearInterval(timer)
            }
        })
    }
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //重置内容
    const formReset = () => {
        form.resetFields()
    }

    return (
        <div className="SettingApp">
            {
                isPay ?
                    <div className={'textCenter'}>
                        <div className={'payOk'}>支付成功</div>
                        <div>
                            <Button className='selfBtn' onClick={handleOk}>
                                确定
                            </Button>
                        </div>
                    </div> :
                    <div>
                        <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
                            <Row gutter={16}>
                                <Col className="gutter-row" span={10}>
                                    <div className='fL'>充值金额</div>
                                    <div>
                                        <Form.Item label="" name="quantity" rules={[
                                            {
                                                required: true,
                                                message: '请输入金额',
                                            }]}>
                                            <InputNumber placeholder={'最低10元'} suffix="￥" style={{width: '100%'}}/>
                                        </Form.Item>
                                    </div>
                                </Col>
                                <Col className="gutter-row" span={8}>
                                    <div className='fL textCenter'>支付方式</div>
                                    <div>
                                        <Form.Item label="" name="payway">
                                            <Select
                                                defaultValue={'支付宝'}
                                                style={{
                                                    width: '100%',
                                                }}
                                                options={[
                                                    {value: '支付宝', label: '支付宝',}
                                                ]}
                                            />
                                        </Form.Item>
                                    </div>
                                </Col>
                                <Col className="gutter-row" span={4}>
                                    <div className='fL textCenter' style={{visibility: 'hidden'}}>1</div>
                                    <div>
                                        <Form.Item label="">
                                            <Button className='selfBtn' htmlType="submit">
                                                确定
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Col>
                            </Row>

                        </Form>
                        {
                            payCode ?
                                <div style={{textAlign: 'center', marginTop: '20px'}}>
                                    <iframe src={payCode} frameBorder="0" width={190} height={100}></iframe>
                                </div> : ''
                        }
                    </div>
            }


        </div>
    )
}

export default RechargeApp
